export default __webpack_public_path__ + "static/Plots0058-02cb19e46adeb1d280223151c036aa91.jpg";